import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import PendingApproveLeaveList from "../components/dashboard/PendingApproveLeaveList";
import TodayAttendanceList from "../components/dashboard/TodayAttendanceList";
import AnalyticsDashboard from "../components/dashboard/AnalyticsDashboard";

const LandingPageTabs = ({ refreshMetaData }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    searchParams.get("tab") || "analytics"
  );

  useEffect(() => {
    if (activeTab === "analytics") {
      setSearchParams({});
    } else {
      setSearchParams({ tab: activeTab });
    }
  }, [activeTab, setSearchParams]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="mt-8">
      <div className="px-5 border-b border-gray-200 py-2 mx-4">
        <ul className="flex items-center space-x-6 text-gray-600">
          <li
            className={`cursor-pointer ${
              activeTab === "analytics" ? "active text-primary font-medium" : ""
            }`}
            onClick={() => handleTabChange("analytics")}
          >
            Analytics
          </li>
          <li
            className={`cursor-pointer ${
              activeTab === "attendance" ? "active" : ""
            }`}
            onClick={() => handleTabChange("attendance")}
          >
            Today's Attendance
          </li>
          <li
            className={`cursor-pointer ${
              activeTab === "leaves" ? "active" : ""
            }`}
            onClick={() => handleTabChange("leaves")}
          >
            Leaves
          </li>
        </ul>
      </div>

      <div className="tab-content mt-4 mx-4">
        {activeTab === "analytics" ? (
          <AnalyticsDashboard />
        ) : activeTab === "attendance" ? (
          <TodayAttendanceList />
        ) : (
          <PendingApproveLeaveList refreshMetaData={refreshMetaData} />
        )}
      </div>
    </div>
  );
};

export default LandingPageTabs;
